import { useEffect, useState } from "react";
import "./style.css";

export function App() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    setActive(localStorage.getItem("activePage") ?? "home");
  }, []);

  const activeStyle = {
    backgroundColor: "#61dafb",
    color: "#282c34",
    padding: "10px 20px",
    borderRadius: "25px",
    fontWeight: "bold",
    cursor: "default",
    transition: "all 0.3s ease",
  };

  const navItemStyle = {
    color: "#e0e0e0",
    cursor: "pointer",
    padding: "10px 20px",
    fontSize: "1.1rem",
    transition: "color 0.3s ease",
  };

  return (
    <div
      className="app"
      style={{
        fontFamily: "'Inter', sans-serif",
        backgroundColor: "#20232a",
        color: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <nav
        style={{
          display: "flex",
          backgroundColor: "#282c34",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem",
          gap: "30px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {["home", "about", "contact"].map((page) => (
          <div key={page}>
            <p
              style={active === page ? activeStyle : navItemStyle}
              onClick={() => {
                localStorage.setItem("activePage", page);
                setActive(page);
              }}
            >
              {page.charAt(0).toUpperCase() + page.slice(1)}
            </p>
          </div>
        ))}
      </nav>

      <main
        style={{
          flex: 1,
          padding: "40px 20px",
          maxWidth: "900px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        {active === "home" && (
          <div
            style={{ textAlign: "center", animation: "fadeIn 0.5s ease-in" }}
          >
            <h1
              style={{
                fontSize: "4rem",
                marginBottom: "10px",
                background: "linear-gradient(to right, #61dafb, #a0e9ff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Jacob Quirk
            </h1>
            <h2
              style={{
                fontSize: "2rem",
                color: "#888",
                marginBottom: "40px",
                fontWeight: "300",
              }}
            >
              Full Stack Developer
            </h2>
            <div
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8",
                color: "#ccc",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              <p>Crafting digital experiences with code.</p>
              <p>
                Specializing in modern web technologies to build scalable,
                high-performance applications.
              </p>
            </div>
            <button
              style={{
                marginTop: "40px",
                padding: "15px 30px",
                fontSize: "1.1rem",
                backgroundColor: "transparent",
                border: "2px solid #61dafb",
                color: "#61dafb",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "all 0.3s",
              }}
              onClick={() => {
                localStorage.setItem("activePage", "contact");
                setActive("contact");
              }}
            >
              Let's Talk
            </button>
          </div>
        )}
        {active === "about" && (
          <div style={{ animation: "fadeIn 0.5s ease-in" }}>
            <h1
              style={{
                borderBottom: "2px solid #61dafb",
                paddingBottom: "15px",
                marginBottom: "30px",
                display: "inline-block",
              }}
            >
              About Me
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                lineHeight: "1.8",
                marginBottom: "30px",
                color: "#ddd",
              }}
            >
              I am Jacob Quirk, a dedicated Full Stack Developer with a passion
              for solving complex problems. My journey in tech is driven by a
              curiosity to understand how things work under the hood and a
              desire to create tools that make life easier.
            </p>

            <h3 style={{ color: "#61dafb", marginBottom: "20px" }}>
              Technical Arsenal
            </h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {[
                "JavaScript (ES6+)",
                "TypeScript",
                "React/Native",
                "Node.js",
                "Express",
                "Rust",
                "C++",
                "Python",
                "Docker",
                "SQL / NoSQL",
                "Git",
                "Cloud Services",
              ].map((skill) => (
                <span
                  key={skill}
                  style={{
                    backgroundColor: "#333",
                    border: "1px solid #444",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "0.9rem",
                    color: "#a0e9ff",
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}
        {active === "contact" && (
          <div style={{ animation: "fadeIn 0.5s ease-in" }}>
            <h1
              style={{
                borderBottom: "2px solid #61dafb",
                paddingBottom: "15px",
                marginBottom: "30px",
                display: "inline-block",
              }}
            >
              Get In Touch
            </h1>
            <p
              style={{
                fontSize: "1.2rem",
                marginBottom: "40px",
                color: "#ddd",
              }}
            >
              I'm currently open to new opportunities and collaborations.
              Whether you have a question or just want to say hi, I'll try my
              best to get back to you!
            </p>

            <div style={{ display: "grid", gap: "20px", fontSize: "1.1rem" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  backgroundColor: "#282c34",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <span style={{ color: "#61dafb", fontWeight: "bold" }}>
                  Email:
                </span>
                <a
                  href="mailto:jjq.quirky@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  jjq.quirky@gmail.com
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  backgroundColor: "#282c34",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <span style={{ color: "#61dafb", fontWeight: "bold" }}>
                  GitHub:
                </span>
                <a
                  href="https://github.com/quincy9000"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  github.com/quincy9000
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  backgroundColor: "#282c34",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <span style={{ color: "#61dafb", fontWeight: "bold" }}>
                  LinkedIn:
                </span>
                <a
                  href="https://linkedin.com/in/jacobquirk"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  linkedin.com/in/jacobquirk
                </a>
              </div>
            </div>
          </div>
        )}
      </main>

      <footer
        style={{
          backgroundColor: "#1a1d23",
          color: "#888",
          textAlign: "center",
          padding: "20px",
          fontSize: "0.9rem",
        }}
      >
        <p style={{ margin: 0 }}>© 2026 Jacob Quirk. Built with React.</p>
      </footer>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default App;
